<div id="whatsapp-container" class="whatsapp-container">
  <a href="https://api.whatsapp.com/send?phone=554832052210" class="whatsapp-float" target="_blank" id="whatsapp-float">
    <img src="../../../assets/imgs/socials/wpp_logo.png" alt="WhatsApp" class="whatsapp-icon">
  </a>
  <button id="close-float" class="close-button" (click)="closeFloater()">✖</button>
</div>